import styled from 'styled-components';
import { Media } from 'assets/Mixins.style';

export const Wrapper = styled.div`
  padding: 0 36px;
  margin: 0 auto;
  padding: ${props => props.theme.padding && props.theme.padding.default};
  border-radius: ${props => props.theme.borderRadius};
  background-color: ${props => props.theme.backgroundColor};
  box-shadow: ${props => props.theme.boxShadow};

  //reset dots styles
  & .slick-dots {
    display: flex !important;
    justify-content: center;
    position: static;
  }
  & .slick-dots li {
    margin: 0;
    width: auto;
    height: auto;
  }
`;

export const Title = styled.div`
  display: block;
  width: max-content;
  margin: ${props => props.theme.margin.default || '0 auto'};
  color: ${props => props.titleColor || props.theme.color};
  transition: 0.2s all;
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
  text-align: center;
  position: relative;

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    margin: ${props => props.theme.margin.md};
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}
`;

export const ItemExternal = styled.a`
  display: flex !important;
  justify-content: center;
  align-items: center;
`;

export const Imagebox = styled.div`
  display: flex;
  justify-content: center;
  max-width: ${props => props.theme.maxWidth || '134px'};
  border: ${props => props.theme.border};
  border-radius: ${props => props.theme.borderRadius};
  padding: ${props => props.theme.padding && props.theme.padding.default};
`;

export const Image = styled.img`
  width: 100%;
`;

export const Decoration = styled.div`
  position: absolute;
  bottom: 3px;
  left: calc(100% + 38px);
  width: 100%;
  max-width: 60px;
`;

export const NextArrow = styled.div`
  display: block;
  position: absolute;
  top: 50%;
  right: -35px;
  width: 36px;
  height: 36px;
  font-size: 0;
  line-height: 0;
  padding: 0;
  transform: translate(0, -50%);
  cursor: pointer;
  border: none;
  outline: none;
  &:before {
    content: '→';
    font-family: 'slick';
    font-size: 36px;
    line-height: 1;
    opacity: 0.75;
    color: #000;
    -webkit-font-smoothing: antialiased;
  }
  &:hover:before {
    opacity: 0.5;
  }
`;

export const PrevArrow = styled.div`
  display: block;
  position: absolute;
  top: 50%;
  left: -35px;
  width: 36px;
  height: 36px;
  font-size: 0;
  line-height: 0;
  padding: 0;
  transform: translate(0, -50%);
  cursor: pointer;
  border: none;
  outline: none;
  &:before {
    content: '←';
    font-family: 'slick';
    font-size: 36px;
    line-height: 1;
    opacity: 0.75;
    color: #000;
    -webkit-font-smoothing: antialiased;
  }
  &:hover:before {
    opacity: 0.5;
  }
`;

export const Dot = styled.div`
  width: ${props => props.theme.size};
  height: ${props => props.theme.size};
  margin: ${props => props.theme.margin && props.theme.margin.default};
  background-color: ${props => props.theme.bgColor};
  border-radius: 50%;

  .slick-active & {
    background-color: ${props => props.theme.bgColorOnActive};
  }
`;
